export default __webpack_public_path__ + "static/media/WhiteCross.d0247ed5.svg";